import type { HTMLAttributes } from "react";
import { cn } from "../../lib/cn.js";

/** Contained filter panel for list/queue pages — matches table card styling. */
export function FilterCard({ className, children, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "rounded-xl border border-border-default bg-surface-overlay p-4",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
